module.exports = __webpack_public_path__ + "static/media/Kuma 1.1.81abe46b.jpg";